import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';
import Alert from '../../shared/Alert/Alert';
import FormatterUtils from '../../../utils/formatter.utils';

export const SummaryPageViewProvider = (
  t,
  params,
  amount,
  getCurrency,
  type,
  getOrganization,
) => {
  switch (type) {
    case EnterAmountType.P2P: {
      return {
        list: [
          {
            title: t('Recipient'),
            subtitle: params.cardTo?.name,
          },
          {
            title: t('Phone number'),
            subtitle: '+' + params.cardTo?.phone,
          },
          {
            title: t('Amount'),
            subtitle: FormatterUtils.currency(
              amount,
              getCurrency(params.currency),
            ),
          },
          {
            title: t('Fee'),
            subtitle: FormatterUtils.currency(
              params.commission?.value,
              getCurrency(params.commission?.currency),
            ),
          },
          {
            title: t('Total amount'),
            subtitle: FormatterUtils.currency(
              params.total?.value,
              getCurrency(params.total?.currency),
            ),
            titleStyleName: 'listItem--bold',
          },
        ],
        alert: {
          info: Alert.Type.INFO,
          message: t(
            "Please be aware that once confirmed you can't undo this transaction.",
          ),
        },
      };
    }
    case EnterAmountType.MICROLOAN: {
      return {
        list: [
          {
            title: t('From credit to {card_name}', {
              '{card_name}': getOrganization(
                params?.beneficiary.organizationCode,
              ),
            }),
            subtitle: FormatterUtils.currency(
              params.amount,
              getCurrency(params.currency),
            ),
          },
          {
            title: t('{installments_count} payments of', {
              '{installments_count}': params?.installments,
            }),
            subtitle: FormatterUtils.currency(
              params.monthlyPayment,
              getCurrency(params.currency),
            ),
          },
          {
            title: t('First payment due date'),
            subtitle: params.date
              ? FormatterUtils.formatDateCustom(
                  params.date,
                  t,
                  'DD/MMM/YYYY',
                  true,
                )
              : '',
          },
          {
            title: t('Interest charges'),
            subtitle: params?.totalInterest
              ? FormatterUtils.currency(
                  params?.totalInterest,
                  getCurrency(params.currency),
                )
              : '',
          },
          {
            title: t('Total payment'),
            subtitle: params?.total
              ? FormatterUtils.currency(
                  params?.total,
                  getCurrency(params.currency),
                )
              : '',
            titleStyleName: 'listItem--bold',
          },
        ],
      };
    }

    case EnterAmountType.MICROLOAN_PAYMENT: {
      return {
        list: [
          {
            title: t('Payment method'),
            subtitle: getOrganization(params.sender?.organizationCode),
          },
          {
            title: t('Payment to'),
            subtitle: t('Credit repayment'),
          },
          {
            title: t('Date'),
            subtitle: params.date
              ? FormatterUtils.formatDateCustom(
                  params.date,
                  t,
                  'DD/MMM/YYYY',
                  true,
                )
              : '',
          },
          {
            title: t('Amount'),
            subtitle: params?.amount
              ? FormatterUtils.currency(
                  params?.amount,
                  getCurrency(params.currency),
                )
              : '',
          },
          {
            title: t('Total payment'),
            subtitle: params?.totalPayment
              ? FormatterUtils.currency(
                  params?.totalPayment,
                  getCurrency(params.currency),
                )
              : '',
            titleStyleName: 'listItem--bold',
          },
        ],
      };
    }
    case EnterAmountType.POS: {
      return {
        list: [
          {
            title: t('Recipient'),
            subtitle: params.beneficiary?.name,
          },
          {
            title: t('Merchant ID'),
            subtitle: params.merchantId,
          },
          {
            title: t('Amount'),
            subtitle: FormatterUtils.currency(
              params.amount,
              getCurrency(params.sender?.currency),
            ),
          },
          {
            title: t('Fee'),
            subtitle: FormatterUtils.currency(
              params.fee,
              getCurrency(params.sender?.currency),
            ),
          },
          {
            title: t('Total payment'),
            subtitle: FormatterUtils.currency(
              params.totalPayment,
              getCurrency(params.sender?.currency),
            ),
            titleStyleName: 'listItem--bold',
          },
        ],
        alert: {
          info: Alert.Type.INFO,
          message: t(
            'Your Merchant ID is unique and linked to your account. If you need to change it, please contact {card name} by dialing',
            {
              '{card name}': getOrganization(params.sender?.organizationCode),
            },
          ),
        },
      };
    }
    case EnterAmountType.SEND_MONEY_TO_COMPANY: {
      return {
        list: [
          {
            title: t('Recipient'),
            subtitle: params.beneficiary?.name,
          },
          {
            title: t('Amount'),
            subtitle: FormatterUtils.currency(
              params.amount,
              getCurrency(params.sender?.currency),
            ),
          },
          {
            title: t('Fee'),
            subtitle: FormatterUtils.currency(
              params.fee,
              getCurrency(params.sender?.currency),
            ),
          },
          {
            title: t('Total payment'),
            subtitle: FormatterUtils.currency(
              params.totalPayment,
              getCurrency(params.sender?.currency),
            ),
            titleStyleName: 'listItem--bold',
          },
        ],
        alert: {
          info: Alert.Type.INFO,
          message: t(
            "Please be aware that once confirmed you can't undo this transaction.",
          ),
        },
      };
    }
  }
};
